/*JB: </>*/
import { Modal, ModalContent,ModalOverlay } from '@chakra-ui/react';
import RSSpinner from '../RSSpinner';
import { ModalStyle as styleRaw } from './ModalStyle';

const DownloadModal = ({ stateProps }) => {

  const style = styleRaw.variants.download;
  return (
    <Modal closeOnOverlayClick={false} sx={style.modal} isCentered isOpen={stateProps.isSpinnerOpen} onClose={stateProps.onSpinnerClose}>
      <ModalOverlay />
      <ModalContent sx={style.modalContent}>
        <RSSpinner
          hasLoading={false}
          stateProps={stateProps}
          message={stateProps.message}
        />
      </ModalContent>
    </Modal>
  );
};

export default DownloadModal;
